import { useEffect, useState } from 'react';
import './MGModalitySubscription.css'
import MGModalitySubscriptionList from './MGModalitySubscriptionList';
import sendLogError from '../../sendLogError';
import { Loading } from '../Loading/Loading';

export default function MGModalitySubscription({ id, context, myModalities, publicURL }) {

    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getData = async () => {
            try {
                setLoading(true);
                const { idToken, selectedUserID } = context;

                const headers = {
                    Authorization: `Bearer ${idToken}`,
                    clientId: selectedUserID,
                };

                const response = await fetch("/Savings/GetSavingModalities", { headers });

                if (!response.ok) {
                    console.error("Error fetching getData:");
                    return;
                }

                const data = await response.json();

                const modalidades = data.filter((item) => (item.id === id));
                const modalidadeList = modalidades.map((item) => {
                    let i = item;
                    i.modalityId = item.modalityId.substring(0, 4);
                    return i
                })

                const res = modalidadeList.filter((modalidade) =>
                    !myModalities.some(item => item.productID === modalidade.modalityId)
                );
                setItems(res);
            } catch (error) {
                console.error("Error fetching portfolio:", error);
                sendLogError(error.message, "populatePortfolioData");
            } finally {
                setLoading(false);
            }
        }
        getData();
    }, []);

    return (
        loading ?
            <div className='MGModalityCardsSubscription-container'>
                <Loading />
            </div> : items.length > 0 ? (<div className='MGModalityCardsSubscription-container'>
                <h4>Subscrever modalidades de Proteção </h4>
                <MGModalitySubscriptionList subscriptionList={items} publicURL={publicURL} />
            </div>) : (<></>)
    );
}
